import React from 'react';

function SvgLink({xlinkHref, viewBox}) {
    return (
        <svg viewBox={viewBox ? viewBox : "0 0 928.6 1000"} className="svg-icon">
            <use xlinkHref={xlinkHref} />
        </svg>
    )
}

export default SvgLink;